import { motion, AnimatePresence } from "motion/react";
import { useVideoSettings } from "../../contexts/videoSettings/videoSettings.hook";
import { usePrefersReducedMotion } from "../../contexts/prefersReducedMotion/prefersReducedMotion.hook";
import styles from "./IntroVideo.module.scss";
import { ENVIRONMENT } from "../../config/constants";

export default function IntroVideo({ children }) {
  const { isMuted, setIsMuted, isPlayingIntroVideo, setIsPlayingIntroVideo } =
    useVideoSettings();
  const { prefersReducedMotion, setPrefersReducedMotion } =
    usePrefersReducedMotion();

  const handleVideoAutoplay = (videoElement: HTMLVideoElement) => {
    if (prefersReducedMotion) {
      return null;
    }

    const playPromise = videoElement.play();
    if (playPromise !== undefined) {
      playPromise
        .catch((error) => {
          if (error.name === "NotAllowedError") {
            console.log("Autoplay blocked – enabling reduced motion.");
            setPrefersReducedMotion(true);
            setIsPlayingIntroVideo(false);
          }
        })
        .then(() => {
          videoElement.play();
        });
    }
  };

  const showControls = ENVIRONMENT === "DEV" || ENVIRONMENT === "LOCAL";

  return (
    <div>
      <AnimatePresence mode="popLayout">
        {isPlayingIntroVideo && (
          <motion.div
            initial={{ opacity: 1 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 2 }}
            style={{ position: "relative" }}
          >
            <video
              key="intro-video"
              ref={(video) => video && handleVideoAutoplay(video)}
              muted={isMuted}
              controls={showControls}
              playsInline
              onEnded={() => {
                setIsPlayingIntroVideo(false);
              }}
              className={styles.video}
            >
              <source src="/skillhouse-intro.mp4" type="video/mp4" />
            </video>
            <motion.button
              initial={{ opacity: 0, x: "-50%", y: "100px" }}
              animate={{ opacity: 1, x: "-50%", y: "0" }}
              transition={{ duration: 1, delay: 1 }}
              exit={{ opacity: 0 }}
              className={styles.muteButton}
              onClick={() => {
                setIsMuted(!isMuted);
              }}
            >
              {isMuted ? "Enable audio" : "Mute audio"}
            </motion.button>
          </motion.div>
        )}
      </AnimatePresence>

      {children}
    </div>
  );
}
